<script>
  const urlParams = new URLSearchParams(window.location.search);
  let searchTerm;
  let hideOptions = false;
  if (urlParams.has("search")) {
    searchTerm = urlParams.get("search");
  } else {
    searchTerm = "";
  }

  let searchTermInput;

  let onClick = () => {
    window.location.reload();
  };

  let onSearch = () => {
    window.location = "/?search=" + searchTermInput.value;
  };

  let resetClick = () => {
    window.location = "/";
  };
</script>

<main class="container flex flex-col items-center justify-center">
  {#if hideOptions == false}
    <div class="relative top-0 right-0 m-4 flex flex-col space-y-2 md:absolute">
      <button
        class="text-xl rounded bg-blue-800 text-gray-400"
        on:click={() => {
          window.location.reload();
        }}>Generate Another Image</button
      >
      <div class="flex flex-row space-x-2">
        <input
          bind:this={searchTermInput}
          class="w-64 rounded h-10 p-4"
          type="text"
          placeholder="search"
          on:change={onSearch}
          value={searchTerm}
        />
        <button
          class="text-xl rounded bg-green-800 text-gray-400 w-10"
          on:click={() => {
            onSearch();
          }}>Go</button
        >
      </div>

      <div class="flex flex-row space-x-4">
        <div class="text-gray-600 flex-grow">ex: nature,water</div>
        <button class="px-1 text-gray-400" on:click={resetClick}>Reset</button>
        <button
          class="px-1 text-gray-400"
          on:click={() => {
            hideOptions = !hideOptions;
          }}>Hide</button
        >
      </div>

      <div class="flex-wrap w-64 text-xs text-gray-400">
        Random Images provided by <a href="https://unsplash.com">Unsplash</a>
      </div>
      <div class="flex-wrap w-64 text-xs text-gray-400">
        Feedback? feedback@somethingtodraw.art
      </div>
    </div>
  {:else}
    <button
      class="absolute top-0 right-0 m-4 px-1 text-gray-400"
      on:click={() => {
        hideOptions = !hideOptions;
      }}>Show</button
    >
  {/if}
  <img
    src="https://source.unsplash.com/random/?{searchTerm}"
    alt="img"
    class="max-h-screen"
    on:click={onClick}
  />
</main>

<style>
</style>
